<script lang="ts">
  import { translation } from '$lib/locale/locale';
  import { colorizeBackground, colorizeText } from '$lib/utils/colorizer';
  import type { Tag } from '$lib/models/tag';
  import { categoryLink, type CategoryType } from '$lib/utils/category';

  const { langHref } = translation();

  let {
    category,
    type,
    small = false,
  }: {
    category: Tag;
    type: CategoryType;
    small?: boolean;
  } = $props();
</script>

<a
  href={categoryLink(langHref, category, type)}
  style="
  --mobile-color: {colorizeText(category.name)}; 
  --desktop-color: var(--text-primary);
  --mobile-background: transparent;
  --desktop-background: {colorizeBackground(category.name)};
  "
  class:small
>
  {category.name}
</a>

<style>
  a {
    border-radius: 28px;
    padding: 5px 8px 5px 8px;
    width: fit-content;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    margin: 0;
    color: var(--desktop-color);
    background-color: var(--desktop-background);
  }

  a:hover {
    text-decoration: none;
    filter: brightness(95%) saturate(1.3);
  }

  .small {
    font-size: var(--xxs-font-size);
    line-height: 16px;
    padding: 3px 7px 3px 7px;
  }

  @media (max-width: 900px) {
    a {
      color: var(--mobile-color);
      background-color: var(--mobile-background);
    }
  }
</style>
